import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DURATION_OPTIONS, type DurationMonths } from '../features/subscription/subscriptionUtils'
import { CheckoutPage } from '../features/checkout/CheckoutPage'

// Deep-Link ?plan=<plan_id>&term=<1|3|6|12> aus /plans bzw. der Subscription-
// Seite — unbekannt/leer wird zu undefined, niemals ein Throw.
const checkoutSearchSchema = z.object({
  plan: z
    .string()
    .optional()
    .transform((value) => (value ? value : undefined))
    .catch(undefined),
  term: z.coerce
    .number()
    .optional()
    .transform((value) =>
      value !== undefined && (DURATION_OPTIONS as readonly number[]).includes(value)
        ? (value as DurationMonths)
        : undefined,
    )
    .catch(undefined),
})

export const Route = createFileRoute('/_auth/checkout')({
  validateSearch: checkoutSearchSchema,
  component: CheckoutRoute,
})

function CheckoutRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <CheckoutPage
      initialPlanId={search.plan}
      initialTerm={search.term}
      onTermChange={(term) => {
        void navigate({ search: (prev) => ({ ...prev, term }) })
      }}
      onCheckoutSuccess={(planId, term, method) => {
        void navigate({ to: '/checkout/success', search: { plan: planId, term, method } })
      }}
    />
  )
}
